module.exports = __webpack_public_path__ + "static/media/Trash.a08c3bd3.svg";